import _ from 'lodash';
const MENURESOURCE = 1;

// 页面路径验证
function validateRoute(url) {
  const pathArr = _.chain(url).trim().trimStart('/').split('/').value();
  return pathArr;
}
// 根据用户权限生成相应的模块路由表
function genrateModRouterMap(menus, result = {}) {
  _.reduce(
    menus,
    (routerMap, menu) => {
      const frontUrl = _.get(menu, 'frontUrl', '');
      if (frontUrl && frontUrl !== '/') {
        const arr = validateRoute(frontUrl);
        if (arr.length) {
          const modName = 'otp';
          routerMap[modName] = _.isArray(routerMap[modName]) ? routerMap[modName] : [];
          routerMap[modName].push({
            path: frontUrl,
          });
        }
      } else if (menu.resourceType === MENURESOURCE && _.get(menu, 'subResources', []).length > 0) {
        genrateModRouterMap(menu.subResources, routerMap);
      }
      return routerMap;
    },
    result,
  );
  return result.otp ? result.otp.map((menu) => menu.path) : [];
}

export { genrateModRouterMap };
